import { ToPrintButton } from '@chronos/ui';
import styled, { css } from 'styled-components';
import { fromDateTime, Maps } from '../../../libs';
import Birth from './Birth';


export default function Lablife4BirthResult({ data }: { data: any }) {
  const { idp, userData } = data;

  const dtString = fromDateTime(userData.date, userData.time);

  return (
    <Container className="print-content" id="print-content">
      <Header className="no-print">
        <ToPrintButton
          className='to-print'
          elements={['#print-content']}
          inseparable={[]}
          excludes={[]}
        >
          <span>Сохранить в PDF</span>
        </ToPrintButton>
      </Header>

      <WrapperMap>
        <StyledMap
          modes={['natal']}
          form={{
            // @ts-ignore
            natal: {
              // @ts-ignore
              dateTime: { date: userData.date, time: userData.time },
              place: userData.place,
              dt: dtString,
            },
          }}
          settings={{
            access: { limited: true },
            diameter: 450,
            theme: 'light',
          }}
        />
      </WrapperMap>

      <Birth {...idp.birth}/>
    </Container>
  )
}

const Container = styled.div`
  padding: 1rem;
  margin: 0 auto;
  width: 70%;

  @media (max-width: 768px) {
    width: auto;
  }

  @media print {
    width: 90% !important;
    font-size: 1.5rem;
  }
`


export const Content = styled.div<{ mode?: string }>`
  position: relative;
  font-size: 1rem;
  color: var(--text-secondary);
  line-height: 1.5;
  text-align: left;

  ${props => props.mode === 'idp' && css`
    width: 50%;
    margin: 0 auto;

    @media (max-width: 768px) {
      width: 100%;
    }
  `}

  & h1 {
    font-size: 3rem;
  }

  & h2 {
    margin-top: 1.5rem;
    margin-bottom: 1rem;
    font-size: 1.5rem !important;
    font-weight: 500 !important;
    line-height: 1.125;
    color: var(--text-primary);

    @media (max-width: 768px) {
      margin: 0 0 0.3rem 0;
      font-size: 1rem;
      line-height: 1.2;
    }

    @media print {
      margin-bottom: 1rem;
    }
  }

  h3 {
    /* font-weight: 900; */
    margin: 1rem 0;
    line-height: 1.125;
    color: var(--text-primary);
  }

  h5 {
    margin-bottom: 1.5em;
    font-size: 0.75rem;
    font-weight: 600;
    color: var(--text-third);
  }

  ul {
    margin-top: 1em;
    margin-bottom: 1.5em !important;
    padding-left: 2em;
    color: var(--text-secondary);

    li:not(:last-child) {
      margin-bottom: 1em;
    }

    li {
      b {
        color: var(--text-primary);
      }

      .block {
        display: flex;
      }
    }

  }

  p {
    margin-bottom: 1.215em;
    color: var(--text-secondary);
  }

  .list-item {
    color: var(--color-gray);
  }

  .list-item_bold {
    font-weight: bold;
  }

  .list-item_black {
    color: var(--text-primary);
  }

  .red-cursive {
    font-style: italic;
    color: #D00000;
    margin-bottom: 1rem !important;
  }

  .signal {
    font-weight: bold;
    color: red;
  }

  .tense-sep {
    margin: 1.75em 0;
    border-top: 1px solid var(--element);
  }

  .aspects-block {
    position: relative;

    @media print {
      margin-bottom: 1.5rem;
    }
  }

  .aspect-item,
  .signal {
    display: block !important;
    position: relative;
    box-sizing: border-box;
    margin-bottom: 1.5rem;
    padding: 1.25rem 1.5rem;
    border-radius: 0.375rem;
    border: 1px solid;

    @media print {
      border-width: 1pt !important;
    }
  }

  .aspect-item.minus {
    background-color: rgba(239, 83, 80, 0.1);
    border-color: rgba(239, 83, 80, 0.5);
  }
  .aspect-item.birth {
    background: rgba(242, 153, 74, 0.1);
    border: 1px solid rgba(242, 153, 74, 0.5);
    @media print {
      border-width: 1pt;
    }
  }
  .aspect-item.equal {
    background-color: rgba(64, 147, 244, 0.1);
    border-color: rgba(64, 147, 244, 0.5);
  }

  .aspect-item.compensation {
    background-color: rgba(115, 178, 48, 0.1);
    border-color: rgba(115, 178, 48, 0.5);
  }

  .signal {
    background-color: rgba(239, 83, 80, 0.1);
    border-color: rgba(239, 83, 80, 0.5);
  }

  .aspect-item h1,
  .signal h1 {
    font-size: 1.125rem;
    line-height: 1;
    margin: 0.625rem 0;
  }

  .aspect-item svg,
  .aspect-item img,
  .signal svg {
    width: 1.5rem;
    height: 1.5rem;
    margin-bottom: 1rem;
  }

  .aspect-item p,
  .signal p {
    margin: 1rem 0;
  }

  .warning {
    background-color: rgba(239, 83, 80, 0.1);
    border-color: rgba(239, 83, 80, 0.5);
  }
`;


const Header = styled.div`
  margin-bottom: 1rem;
  text-align: left;

  @media print {
    display: none;
  }
`;

const StyledMap = styled(Maps)`
  margin: 5rem 1rem;

  @media (max-width: 768px) {
    & {
      width: 83% !important;
      height: auto !important;
    }
      .maps-container > svg {
        width: initial !important;
        height: initial !important;
      }
  }

  svg {
    overflow: visible;
  }

  @media print {
    width: 100% !important;
    max-width: 450px !important;

  }
`;

const WrapperMap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;

  page-break-inside: avoid !important;
  break-inside: avoid !important;

  overflow: hidden;
`;
